<template>
  <div id="hrms41e-detail-tab1" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion" href="#tab1">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['HRMS41EC2']['60'] }} / {{ labels['HRMS41EC2']['40'] }}
      </h3>
    </div>
    <div id="tab1" class="panel-collapse collapse tab-detail">
      <div class="panel-body">
        <div class="col-md-5">
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRMS41EC2']['120'] }}</label>
              <div class="col-md-6">
                <input type="radio" name="stapphinv" value="P" v-model="detailTab1.detail.stapphinv" > <span class="radio-text">{{ labels['HRMS41EC2']['150'] }}</span>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label"></label>
              <div class="col-md-6">           
                <input type="radio" name="stapphinv" value="C" v-model="detailTab1.detail.stapphinv" > <span class="radio-text">{{ labels['HRMS41EC2']['160'] }}</span>
              </div>
            </div>
          </form>
          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-4 control-label">{{ labels['HRMS41EC2']['130'] }}</label>
              <div class="col-md-6">
                 <textarea  class="form-control" 
                            v-model="detailTab1.detail.desnote"
                            maxlength="100" 
                            v-validate="'max:100'"
                            data-vv-name="desnote"
                            :has-error="errors.has('desnote')"></textarea> 
                  <div class="text-error" v-show="errors.has('desnote')">{{errors.first('desnote')}}</div>
                  <div class="remark-limit-character">{{ dispLimitLabel(100) }}</div> 
              </div>
            </div>
          </form>
          <div class="box-footer">
            <button type="button" class="btn bg-color-skin" @click="save()"><i class="fa fa-check-circle"></i>{{ labelsButton['save'] }}</button>  
          </div>
        </div>

        <div class="col-md-7" v-if="detailTab1.table1.rows.length > 0">
          <div class="col-md-12 clear-padding">
            <div class="evaluation-wrapper">
              <template v-for="dataGroup in detailTab1.table1.rows">
                <group  :labels="labels"
                        :dataGroup="dataGroup"
                        :choices="detailTab1.table2.rows"
                        name="tab1"/>
              </template>
            </div>
          </div>
          <div class="col-md-12 clear-padding">
            <div class="evaluation-sum clearfix">
              <div style="float: left;">{{ detailTab1.detail.desc_qtyscor }}</div><div style="float: right;">{{ labels['HRMS41EC2']['180'] }} {{ calResultScore(detailTab1.table1.rows) }}/{{ calTotalScore(detailTab1.table1.rows) }} </div> 
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import group from 'components/hrms41e/group'
import { constLabels } from 'assets/js/constLabels.js'

export default {
  name: 'hrms41e-detail-tab1',
  props: [ 'labels', 'detailTab1', 'labelsButton', 'detail', 'postHrms41eTab1Save', 'searchIndex', 'indexSelected' ],
  methods: {
    dispLimitLabel (limit) {
      return constLabels('limitTo') + ' ' + limit + ' ' + constLabels('characters')
    },
    saveParams () {
      return {
        searchIndex: this.searchIndex,
        indexSelected: this.indexSelected,
        detailTab1: this.detailTab1
      }
    },
    save () {
      let _this = this
      this.$validator.validateAll().then(result => {
        if (result) {
          _this.postHrms41eTab1Save(_this.saveParams())
        }
      })
    },
    calResultScore (dataGroups) {
      return dataGroups.map((dataGroup) => {
        return parseFloat(dataGroup.qtyscor)
      }).reduce((a, b) => {
        return parseFloat(a) + parseFloat(b)
      })
    },
    calTotalScore (dataGroups) {
      return dataGroups.map((dataGroup) => {
        return parseFloat(dataGroup.qtyfscor)
      }).reduce((a, b) => {
        return parseFloat(a) + parseFloat(b)
      })
    }
  },
  components: {
    group
  }

}
</script>



// WEBPACK FOOTER //
// detailTab1.vue?782fffac